<script lang="ts">
  import cart from "../stores/cart";
  import type { CartItem } from "../stores/cart";

  export let item: CartItem;
</script>

<div class="flex items-center space-x-4">
  <img src={item.image} alt={item.title} class="w-12 h-12 object-contain" />

  <div class="flex-1">
    <div class="mb-1 text-gray-900">{item.title}</div>

    <div class="flex items-center">
      <button
        title="increase"
        class="text-gray-500 hover:text-olli-500"
        on:click={() =>
          cart.setItemCount(item.id, Math.max(0, item.quantity - 1))}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <span class="mx-2 text-sm text-gray-500">{item.quantity}</span>

      <button
        title="decrease"
        class="text-gray-500 hover:text-olli-500"
        on:click={() => cart.setItemCount(item.id, item.quantity + 1)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
            clip-rule="evenodd"
          />
        </svg>
      </button>

      <button
        title="remove"
        class="ml-5 text-gray-500 hover:text-olli-500"
        on:click={() => cart.removeItem(item.id)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </div>

  <div class="font-bold text-olli-500">{@html item.priceTotalHtml}</div>
</div>
